<template>
  <a
    v-if="url"
    :href="url"
    class="category-discount-title category-discount-title--link"
  >
    <svg
      class="category-discount-title__icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path
        d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
      ></path>
      <line x1="7" y1="7" x2="7.01" y2="7"></line>
    </svg>
    <span>{{ $translate("OD3dprimaV2::Template.categoryDiscountTitle") }}</span>
    <svg
      class="category-discount-title__arrow"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9 16"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M1 1l6.364 7L1 15"></path>
    </svg>
  </a>
  <b v-else class="category-discount-title">{{
    $translate("OD3dprimaV2::Template.categoryDiscountTitle")
  }}</b>
</template>

<script>
export default {
  name: "category-discount-title",

  props: {
    url: {
      type: String,
      default: "",
    },
  },
};
</script>
